import {injectable} from "tsyringe";
import {SaveTranslationOverrideCommand, TranslationOverridePayload} from "../commands/save-translation-override.command";
import {transformer} from "../decorators/transformer.decorator";
import {DataTransferObject} from "../domain/dtos/data-transfer-object.interface";
import {AbstractCommandToDtoTransformer} from "./abstract-command-to-dto.transformer";

/**
 * Maps `SaveTranslationOverrideCommand` to the backend command DTO (O2D-PRD-092).
 *
 * The payload is already a plain `Record<string,string>` override set — NOT a
 * proxified entity — so the generic command-to-dto fallback (which insists on a
 * ChangeTracker proxy and THROWS otherwise, `transformer.helper.ts:45-74`) must
 * not be reached. Registering this dedicated transformer (via the side-effect
 * import in `transformers/index.ts`) is what routes the command through here;
 * `toDTO` returns the override set unchanged so the full set is persisted.
 */
@injectable()
@transformer({
    source: SaveTranslationOverrideCommand,
    target: `dto`
})
export class SaveTranslationOverrideCommandToDtoTransformer extends AbstractCommandToDtoTransformer<TranslationOverridePayload> {

    protected async toDTO(payload: TranslationOverridePayload): Promise<DataTransferObject> {
        return payload as unknown as DataTransferObject;
    }
}
